import PropTypes from "prop-types";
import React, { Component } from "react";
import { propTypes } from "react-bootstrap/esm/Image";
import { withTranslation } from "react-i18next";
import { Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap";

class CustomizeAlertModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <Modal
          isOpen={this.props.show}
          toggle={this.props.onCancel}
          style={{
            marginTop: "65px",
            justifyContent: "flex-start"
          }}
          size="xs"
          backdrop={"static"}
          id="staticBackdrop"
        >
          <ModalBody>
            <Row >
              <Col lg={18}>
                <div>
                  <h4>
                    <i
                      className="bx bx-info-circle"
                      style={{
                        marginRight: "3px",
                        marginTop: "-4px",
                        fontSize: "1.5em",
                        color: "yellow",
                      }}
                    />
                    {this.props.title}
                  </h4>
                </div>
                <div className="modal-body"
                  style={{
                    justifyContent: "flex-start"
                  }}
                >
                  <p>{this.props.alertMessage}</p>
                </div>
              </Col>
            </Row>
            <ModalHeader style={{ marginBottom: "10px" }}></ModalHeader>
            <Row>

              <Col lg={12}>
                <div style={{ textAlign: "right" }}>
                  {this.props.onConfirm && <button
                    type="button"
                    // className={"btn btn-"+ this.propTypes.confirmBtnBsStyle.toString()}
                    className="btn btn-primary me-1"
                    onClick={this.props.onConfirm}
                  >
                    {this.props.t("yes")}
                  </button>}
                  {this.props.showCancel ? 
                   <button
                   type="button"
                   // className={"btn btn-"+ this.propTypes.cancelBtnBsStyle.toString()}
                   className="btn btn-primary me-1"
                   onClick={this.props.onCancel}
                 >
                   {this.props.t("no")}
                 </button>
                  
                  :null }
                 
                </div>
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }
}

CustomizeAlertModal.propTypes = {
  className: propTypes.any,
  title: PropTypes.any,
  alertMessage: PropTypes.any,
  showCancel: PropTypes.bool,
  confirmBtnBsStyle: propTypes.any,
  cancelBtnBsStyle: propTypes.any,
  style: propTypes.any,
  onConfirm: PropTypes.func,
  onCancel: propTypes.func,
  show: PropTypes.any,
  t: PropTypes.any,
};

export default withTranslation()(CustomizeAlertModal);
